import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { v_InventoryBus } from "./v_InventoryBus";
import { InventoryLocationXrefBus } from "./InventoryLocationXrefBus";
import { InventoryThresholdOverrideBus } from "./InventoryThresholdOverrideBus";
import { InventorySupplierXrefBus } from "./InventorySupplierXrefBus";
import { InventoryBus } from "./InventoryBus";
import { InventoryConsumablesBus } from "./InventoryConsumablesBus";
import { InventoryConsMatchesBus } from "./InventoryConsMatchesBus";
import { InventoryThresholdOverrideBranchBus } from "./InventoryThresholdOverrideBranchBus";
import { InventoryPartNbrsBus } from "./InventoryPartNbrsBus";

export class PricingProjectionParam extends BaseBus
{
    constructor(data: PricingProjectionParam) {
        super();
        if (data) {
            this.startDate = CommonFunctions.getDate(data.startDate);
            this.endDate = CommonFunctions.getDate(data.endDate);
            this.customerId = data.customerId;
            this.locationIds = [];
            if (data.locationIds) {
                this.locationIds = data.locationIds;
            }
            this.accountClassIds = [];
            if (data.accountClassIds) {
                this.accountClassIds = data.accountClassIds;
            }
            this.divisionIds = [];
            if (data.divisionIds) {
                this.divisionIds = data.divisionIds;
            }

        }
    }

    CID(): any {
        return this.customerId;
    }
    setId(id: any) {
        this.customerId = id;
    }
    initialize(data: PricingProjectionParam) {
        super.initialize(data);
        this.startDate = CommonFunctions.getDate(data.startDate);
        this.endDate = CommonFunctions.getDate(data.endDate);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setBeforeSave() {
    }
    setCommon(userId: any, date: Date, companyId: any = null) {

    }

    divisionIds: string[];
    customerId: string;
    locationIds: string[];
    accountClassIds: string[];
    startDate: Date;
    endDate: Date;
    billingCodes: string;

}
